/**
 * Roster de especiais e tabela de combos (M4, AC-M4-05). 5 heróis, 5 especiais distintos; os 10
 * combos de ultimate são exatamente os C(5,2)=10 pares de especiais (doc 03 Apêndice A). A detecção
 * na sim (tick 3b) é data-driven via `comboDe`. Par de especiais IGUAIS (ex.: 2× Pip) cai no combo
 * padrão 'Festa de Cenoura' (preserva o AC-M2-04).
 */
export const HEROI_ESPECIAL: Record<string, string> = {
  pip: 'muralha', // Muralha de Cenouras
  luma: 'lua_cheia', // Lua Cheia
  zig: 'fabrica', // Fábrica Portátil
  nina: 'chuva_estrelas', // Chuva de Estrelas
  gata: 'debandada', // Debandada Fofa
};

export const ESPECIAIS: readonly string[] = ['muralha', 'lua_cheia', 'fabrica', 'chuva_estrelas', 'debandada'];

export interface ComboDef {
  nome: string;
  a: string;
  b: string;
}

/** os 10 combos = todos os pares distintos dos 5 especiais (doc 03 Apêndice A). */
export const COMBOS: readonly ComboDef[] = [
  { nome: 'Céu de Festa', a: 'lua_cheia', b: 'chuva_estrelas' },
  { nome: 'Churrasco de Cenoura', a: 'muralha', b: 'lua_cheia' },
  { nome: 'Recreio Selvagem', a: 'debandada', b: 'fabrica' },
  { nome: 'Eclipse Saltitante', a: 'lua_cheia', b: 'debandada' },
  { nome: 'Foguete de Brinquedo', a: 'fabrica', b: 'chuva_estrelas' },
  { nome: 'Muralha Estrelada', a: 'muralha', b: 'chuva_estrelas' },
  { nome: 'Fortaleza de Lata', a: 'muralha', b: 'fabrica' },
  { nome: 'Estouro na Muralha', a: 'muralha', b: 'debandada' },
  { nome: 'Fábrica Enluarada', a: 'lua_cheia', b: 'fabrica' },
  { nome: 'Meteoros Selvagens', a: 'debandada', b: 'chuva_estrelas' },
];

export const COMBO_PADRAO = 'Festa de Cenoura';

/** nome do combo para um par de especiais (ordem indiferente); padrão se não houver par nomeado. */
export function comboDe(especialA: string, especialB: string): string {
  for (const c of COMBOS) {
    if ((c.a === especialA && c.b === especialB) || (c.a === especialB && c.b === especialA)) return c.nome;
  }
  return COMBO_PADRAO;
}

export function especialDoHeroi(heroId: string): string {
  return HEROI_ESPECIAL[heroId] ?? 'muralha';
}
